import { EquipmentTypeDisplay, NodeBody, NodeContainer, NodeErrorIcon, NodeHeader, NodePrompts } from '@/nodes/NodeUI';
import { equipmentTypeState } from '@/state';
import type { EquipmentTypeId, GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import { useAtomValue } from 'jotai/index';
import { loadable } from 'jotai/utils';
import { type FC, useContext } from 'react';
import { FlowParamsContext } from '../app/FlowInitializer';
import type { ScanNodeType } from './types';

const ScanNode: FC<NodeProps<ScanNodeType>> = ({ id, selected, data }) => {
    const paths = outgoingHandles.scan(id as GuideNodeId, data);
    const { spaceId } = useContext(FlowParamsContext);
    const typeLoadable = useAtomValue(
        loadable(
            equipmentTypeState(data.equipmentTypeId === '[context]' ? ('_' as EquipmentTypeId) : data.equipmentTypeId),
        ),
    );
    const type = typeLoadable.state === 'hasData' ? typeLoadable.data : undefined;

    return (
        <NodeContainer>
            <NodeErrorIcon id={id} />
            <NodeHeader id={id} type={data.type} title="Model Number" />
            <NodeBody selected={selected}>
                <NodePrompts
                    prompts={[
                        {
                            text: `Great, let's grab that model number so that we can automatically pull in all relevant data for your ${(type?.title || 'equipment').toLowerCase()}.`,
                        },
                    ]}
                />
                {data.equipmentTypeId && (
                    <div className="flex flex-col items-center justify-center p-3">
                        <EquipmentTypeDisplay spaceId={spaceId} typeId={data.equipmentTypeId} />
                    </div>
                )}
            </NodeBody>

            <Handle type="target" position={Position.Left} />
            <Handle type="source" id={paths.next} position={Position.Right} />
        </NodeContainer>
    );
};

export default ScanNode;
